/**
 * OrgAdminLinkPage — used for org-admin layout sub-routes that
 * open the existing full-featured pages (transactions, history, projects, analytics).
 * Renders a brief landing with a redirect link.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const CARD = { borderColor: '#f4d6df', background: '#fff' };
const PINK = '#c44569';

export default function OrgAdminLinkPage({ title, description, Icon, targetPath, linkLabel }) {
  return (
    <div className="max-w-xl space-y-4 pb-10">
      <div className="rounded-3xl border p-6 shadow-sm" style={CARD}>
        {Icon ? <Icon size={28} className="mb-3" style={{ color: PINK }} /> : null}
        <h1 className="text-xl font-black text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-1">{description}</p>
      </div>
      <Link
        to={targetPath}
        className="inline-flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold text-white shadow-md transition hover:opacity-90"
        style={{ background: PINK }}
      >
        {linkLabel || `Open ${title}`} →
      </Link>
    </div>
  );
}
